import { render, staticRenderFns } from "./RecentlyHotTravelGroups.vue?vue&type=template&id=6170e238&"
import script from "./RecentlyHotTravelGroups.vue?vue&type=script&lang=js&"
export * from "./RecentlyHotTravelGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports